
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Posterior_dislocation_of_shoulder',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Posterior_dislocation_of_shoulder.vue